import {useMemo} from 'react';

export default function useQueryParams(): URLSearchParams {
  return useMemo(() => new URLSearchParams(window.location.search), []);
}
